<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Słownik ryzyk'" [name]="'Lista'"></app-breadcrumb>
<div class="risk-dictionary-list-container" fxLayout="column" fxLayoutGap="15px">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
    <mat-form-field style="display: none" class="risk-dictionary-list-filter">
      <mat-label>UUID</mat-label>
      <input matInput placeholder="UUID" name="uuid" [(ngModel)]="initialFilters.uuid">
    </mat-form-field>

    <mat-form-field class="risk-dictionary-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Nazwa" name="name" [(ngModel)]="initialFilters.name">
    </mat-form-field>

    <app-dict-insurance-companies
      (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
      [multiple]="true" label="TU" class="risk-dictionary-list-filter"
      [(ngModel)]="initialFilters.in$insuranceCompany"
      name="in$insuranceCompany"
    ></app-dict-insurance-companies>
  </form>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center center">
      <button *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <div fxLayout="column" fxFlex="100">
    <table mat-table [dataSource]="items" multiTemplateDataRows class="table-risk">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Nazwa </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="logo">
        <th mat-header-cell *matHeaderCellDef> Logo </th>
        <td mat-cell *matCellDef="let element" style="text-align: center" (click)="expandElement(element)">
          <img
            *ngIf="element.insuranceCompany.imageLocation"
            src="/rest/crm/insuranceCompany/{{element.insuranceCompany.id}}/image"
            alt="Logo" height="30"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="insuranceCompany">
        <th mat-header-cell *matHeaderCellDef> TU </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          <a class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
            {{element.insuranceCompany.name}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="insuranceCompanyType">
        <th mat-header-cell *matHeaderCellDef> Typ TU </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.insuranceCompany.type?.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="policyTypes">
        <th mat-header-cell *matHeaderCellDef> Typ polisy </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          <ng-container *ngFor="let policyType of element.policyTypes">
            {{policyType.name}}<br>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            (click)="edit(element)"
            [disabled]="!(userPermissions | async).settlement.write"
            color="accent"
          ><mat-icon>edit</mat-icon></button>
          <button
            [disabled]="!(userPermissions | async).settlement.delete"
            mat-icon-button
            (click)="delete(element)"
            color="warn"
          ><mat-icon>delete</mat-icon></button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-row-td">
          <div class="expanded-data" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
            <div fxFlex="100" *ngIf="element == expandedElement">
              <app-risk-dict-group-view
                [riskDictionary]="element"
                (modifyClicked)="modify = true"
                *ngIf="!modify"
                fxFlex="100"
              ></app-risk-dict-group-view>
              <app-risk-dict-group-form
                [riskDictionary]="element"
                (closeModification)="modify = false; modificationClosed()"
                *ngIf="modify"
                fxFlex="100"
              ></app-risk-dict-group-form>
            </div>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        class="table-row"
        mat-row *matRowDef="let element; let row; columns: displayedColumns;"
        [class.expanded-row]="expandedElement === element"
        [class.not-expanded-row]="expandedElement && expandedElement !== element"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-data-row"></tr>
    </table>

    <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
